import Vue from 'vue';

import YubinCheck from './assets/vue/YubinCheck.vue';
import Form from './assets/vue/Form.vue';
import Contact from './assets/vue/Contact.vue';
import MV from './assets/vue/Mv.vue';
import CV from './assets/vue/Cv.vue';
import PageScroll from './assets/js/PageScroll';
import Accordion from './assets/js/Accordion';
import ContactModal from './assets/js/ContactModal';
import GoogleAnalytics from './assets/js/GoogleAnalytics';

// SYSTEM-1009 AB検証用
import ABTest from './assets/js/Abtest';
ABTest();


new Vue({
  render: createElement => createElement(YubinCheck),
  el: '#YubinCheckApp',
});

new Vue({
  render: createElement => createElement(Form),
  el: '#FormApp',
});

new Vue({
  render: createElement => createElement(Contact),
  el: '#Contact',
})

new Vue({
  render: createElement => createElement(MV),
  el: '#Mv',
})

const cvs = document.querySelectorAll('.Cv');
cvs.forEach((el, i) => {
  new Vue({
    render: createElement => createElement(CV),
    el: el,
  })
});

const pagescroll = new PageScroll();
pagescroll.init();
Accordion();
ContactModal();
GoogleAnalytics();
